export default "__VITE_ASSET__e621518c__"